import { Loader, Skeleton } from '@mantine/core'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const YTDEtcVsAppliedSkeleton = () => {
  const unitSuffix = unitConverter.evapotranspiration().suffix()

  return (
    <div>
      <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div css={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <h3 css={{ margin: 0 }}>{translate.phrases.banyanApp('Year to Date ETc vs Applied')}</h3>
          <Loader size="sm" color="blue" />
        </div>
        <div css={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <div css={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div
              css={{
                width: 24,
                height: 3,
                backgroundColor: colors.lineChartSeriesTwo,
                borderRadius: 2,
              }}
            />
            <span css={{ fontSize: 13 }}>{`${translate.phrases.banyanApp('ETc')} (${unitSuffix})`}</span>
          </div>
          <div css={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div
              css={{
                width: 24,
                height: 3,
                backgroundColor: colors.applied,
                borderRadius: 2,
              }}
            />
            <span css={{ fontSize: 13 }}>{`${translate.phrases.banyanApp('Applied')} (${unitSuffix})`}</span>
          </div>
        </div>
      </div>
      <Skeleton height={300} mb={20} radius="sm" animate />
      <Skeleton height={300} mb={20} radius="sm" animate />
      <Skeleton height={60} radius="sm" animate />
    </div>
  )
}
